export const HOME = 'home'
export const ABOUT = 'about'
export const PROGRESS = 'work-in-progress'
export const PROCESS = 'process'
export const CONNECT = 'connect'
export const PORTFOLIO = 'portfolio'
export const FOUR = '404'
